"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.261 5.487c-.882-1.382.618-3.044 2.083-2.312L16.11 8.556c1.19.595 1.19 2.293 0 2.887L5.344 16.825c-1.465.731-2.965-.93-2.083-2.312L6.141 10zm1.142-.888a.2.2 0 0 0 .038.135l2.964 4.643c.242.38.242.866 0 1.245l-2.964 4.644a.2.2 0 0 0-.038.135.23.23 0 0 0 .06.123.23.23 0 0 0 .116.072.2.2 0 0 0 .139-.024l10.766-5.38a.214.214 0 0 0 0-.384L4.718 4.428a.2.2 0 0 0-.139-.024.23.23 0 0 0-.117.071.23.23 0 0 0-.059.124",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SendIcon20.js.map